module.exports = __webpack_public_path__ + "img/favorites.e149f47d.svg";